import React, { lazy, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { PageLoading } from '@invision/ui';
import { AUTHENTICATION_ROUTES } from '../constants';
import { ProtectedRoute } from '../components/shared/ProtectedRoute';
import { OAuthCallbackPage } from '../components/oAuth/OAuthCallbackPage';

const LoginPage = lazy(() => import('../components/login/LoginPage'));
const ForgotPasswordPage = lazy(
  () => import('../components/forgotPassword/ForgotPasswordPage')
);
const UpdateCredentialsPage = lazy(
  () => import('../components/updateCredentials/UpdateCredentialsPage')
);
const IdpCallbackPage = lazy(() => import('../components/idp/IdpCallbackPage'));
const LogoutPage = lazy(() => import('../components/logout/LogoutPage'));
const NoModuleAccessPage = lazy(
  () => import('../components/noAccess/NoModuleAccessPage')
);
const AccessRedirectPage = lazy(
  () => import('../components/accessRedirect/AccessRedirectPage')
);

const PageLoadingIndicator = <PageLoading open />;

export function AuthenticationRouter() {
  return (
    <Suspense fallback={PageLoadingIndicator}>
      <Switch>
        <Route exact path={AUTHENTICATION_ROUTES.LOGIN}>
          <LoginPage />
        </Route>
        <Route exact path={AUTHENTICATION_ROUTES.FORGOT_PASSWORD}>
          <ForgotPasswordPage />
        </Route>
        <ProtectedRoute
          exact
          path={AUTHENTICATION_ROUTES.UPDATE_CREDENTIALS}
          requiresAuth
          component={UpdateCredentialsPage}
        />
        <Route exact path={AUTHENTICATION_ROUTES.UPDATE_CREDENTIALS_WITH_TOKEN}>
          <UpdateCredentialsPage />
        </Route>
        <Route exact path={AUTHENTICATION_ROUTES.IDP_CALLBACK}>
          <IdpCallbackPage />
        </Route>
        <Route exact path={AUTHENTICATION_ROUTES.OAUTH_CALLBACK}>
          <OAuthCallbackPage />
        </Route>
        <Route exact path={AUTHENTICATION_ROUTES.LOGOUT}>
          <LogoutPage />
        </Route>
        <ProtectedRoute
          exact
          path={AUTHENTICATION_ROUTES.NO_MODULE_ACCESS}
          requiresAuth
          showErrorNotification={false}
          component={NoModuleAccessPage}
        />
        <Route exact path={AUTHENTICATION_ROUTES.ACCESS_REDIRECT}>
          <AccessRedirectPage />
        </Route>
        {/* Default redirect to login */}
        <Redirect to={AUTHENTICATION_ROUTES.LOGIN} />
      </Switch>
    </Suspense>
  );
}
